import { useTranslation } from 'react-i18next';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';

import { getEmailLogsById } from 'apis/projectProposals.api';
import { TIMEZONE_VN } from 'constant';

export default function ViewHistory({ projectProposalId, visible, setVisible }) {
  const { t } = useTranslation();

  const { data, isLoading } = useQuery(
    ['projectProposal-emailLogs', projectProposalId],
    ({ queryKey: [, _projectProposalId] }) => getEmailLogsById(_projectProposalId),
    { enabled: !!projectProposalId }
  );

  const formatIndex = (_, { rowIndex }) => rowIndex + 1;

  const formatSentTime = (value) => {
    const datetime = new Date(value.sentTime);
    datetime.setHours(datetime.getHours() + 7);
    const formattedDatetime = datetime.toLocaleString('vi-VN', {
      timeZone: TIMEZONE_VN,
    });
    return <p className="text-center">{formattedDatetime}</p>;
  };

  return (
    <Dialog
      header={<p className="text-blue-500">{t('projectProposal.viewEmailLogs.title')}</p>}
      visible={visible}
      position="center"
      style={{ maxWidth: '700px', minWidth: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <DataTable
        value={data?.data.emailLogs ?? []}
        showGridlines
        scrollable
        dataKey="sentTime"
        loading={isLoading}
        emptyMessage={t('projectProposal.viewEmailLogs.emptyMessage')}
      >
        <Column
          header={t('formLayout.numericalOrder')}
          body={formatIndex}
          className="w-3rem text-center"
        />
        <Column
          header={t('projectProposal.viewEmailLogs.subject')}
          field="subject"
          className="w-30rem"
          style={{ minWidth: '15rem', whiteSpace: 'pre-wrap' }}
        />
        <Column
          header={t('projectProposal.viewEmailLogs.sentTime')}
          body={formatSentTime}
          className="w-20rem"
          style={{ minWidth: '15rem' }}
        />
      </DataTable>
    </Dialog>
  );
}

ViewHistory.propTypes = {
  projectProposalId: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};
